import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import * as moment from 'moment';
var Caract_proy_garantiaComponent = /** @class */ (function () {
    function Caract_proy_garantiaComponent() {
        this.rows = [];
        this.matcher = new FormService();
        this.encontrado = localStorage.getItem("form");
        this.maxDate = moment().toDate();
        this.form = new FormGroup({
            total_predios_apro: new FormControl('', [Validators.min(0), Validators.pattern(/[0-9]*/)]),
            total_predios_garantia: new FormControl('', [Validators.min(0), Validators.pattern(/[0-9]*/)]),
            cambios: new FormControl(''),
            mod_aprobada: new FormControl(''),
            resolucion: new FormControl(''),
            fecha: new FormControl({ value: '', disabled: true })
        });
        if (!JSON.parse(localStorage.getItem("caract_proy_garantia"))) {
            localStorage.setItem("caract_proy_garantia", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("caract_proy_garantia"));
            this.form.controls['total_predios_apro'].setValue(this.rows[0] ? this.rows[0].total_predios_apro : '');
            this.form.controls['total_predios_garantia'].setValue(this.rows[0] ? this.rows[0].total_predios_garantia : '');
            this.form.controls['cambios'].setValue(this.rows[0] ? this.rows[0].cambios : '');
            this.form.controls['mod_aprobada'].setValue(this.rows[0] ? this.rows[0].mod_aprobada : '');
            this.form.controls['resolucion'].setValue(this.rows[0] ? this.rows[0].resolucion : '');
            this.form.controls['fecha'].setValue(this.rows[0] ? this.rows[0].fecha : null);
        }
        this.caract_proy_garantia = { total_predios_apro: '', total_predios_garantia: '', cambios: '', mod_aprobada: '', resolucion: '', fecha: null };
    }
    Caract_proy_garantiaComponent.prototype.add_caract_proy_garantia = function (event, type) {
        if (event) {
            this.fecha = moment(event.value).format('DD/MM/YYYY');
        }
        else {
            var temp = JSON.parse(localStorage.getItem("caract_proy_garantia"));
            if (temp > 0) {
                this.fecha = temp[0].fecha;
            }
        }
        localStorage.setItem("caract_proy_garantia", JSON.stringify([]));
        this.actualRow = localStorage.getItem("caract_proy_garantia");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            total_predios_apro: this.form.value.total_predios_apro,
            total_predios_garantia: this.form.value.total_predios_garantia,
            cambios: this.form.value.cambios,
            mod_aprobada: this.form.value.mod_aprobada,
            resolucion: this.form.value.resolucion,
            fecha: this.fecha
        });
        localStorage.setItem("caract_proy_garantia", JSON.stringify(this.rows));
    };
    Caract_proy_garantiaComponent.prototype.delete_caract_proy_garantia = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("caract_proy_garantia", JSON.stringify(this.rows));
            }
        }
    };
    return Caract_proy_garantiaComponent;
}());
export { Caract_proy_garantiaComponent };
